<section class="trust py-5 text-center">
  <div class="container">
    <h2 class="trust__title display-4 mb-4">{{ title }}</h2>
    <div class="trust__badge d-flex justify-content-center px-3 py-2 rounded-2">
      <app-trustbox></app-trustbox>
    </div>
    <p class="trust__subtitle mt-4 mb-0 mx-auto">{{ subtitle }}</p>
  </div>
</section>
